@import "src/styles/common/_colors.scss";

.rawDataWrapper {
    // display: flex;
    // flex: 1 1;
    // flex-direction: column;   
    height: 100%;
}
